document.addEventListener('DOMContentLoaded', () => {
	var hostdomainname = 'https://'+window.location.hostname; 

	if(window.location.hostname == 'devmagiauslug.kylos.pl'){
		var hostdomainname = 'https://'+window.location.hostname + '/mateuszmrozowski'; 
	}

	if (document.querySelector('.formBlock .wpcf7')) {
		const button = document.querySelector(
		'.formBlock .wpcf7 button.newHomePagebutton.newHomePagebutton--primary'
		);
		const buttonAppend = `<div class="newHomePagebutton__gradient"><img src="${hostdomainname}/wp-content/themes/mateuszmrozowski/img/svg/arrow.svg" alt=""></div>`;
		button.innerHTML += buttonAppend;
	}
	if (document.querySelector('.contact__form .wpcf7')) {
		const button = document.querySelector(
			'.contact__form .wpcf7 button.newHomePagebutton.newHomePagebutton--primary'
		);
		const buttonAppend = `<div class="newHomePagebutton__gradient"><img src="${hostdomainname}/wp-content/themes/mateuszmrozowski/img/svg/arrow.svg" alt=""></div>`;
		button.innerHTML += buttonAppend;
	}
	if (document.querySelector('.contactDetails__form					 .wpcf7')) {
		const button = document.querySelector(
			'.contactDetails__form						 .wpcf7 button.newHomePagebutton.newHomePagebutton--primary'
		);
		const buttonAppend = `<div class="newHomePagebutton__gradient"><img src="${hostdomainname}/wp-content/themes/mateuszmrozowski/img/svg/arrow.svg" alt=""></div>`;
		button.innerHTML += buttonAppend;
		const socials = document.querySelector('.contactDetails .socials');
		const formButton = document.querySelector('.contactDetails .form__button');
		formButton.innerHTML =
			'<div class="socials">' +
			socials.innerHTML +
			'</div>' +
			formButton.innerHTML;
            socials.remove()
	}
	if (document.querySelector('.newsletter .wpcf7')) {
		const button = document.querySelector(
			'.newsletter .wpcf7 button.newHomePagebutton.newHomePagebutton--primary'
		);
		const buttonAppend = `<div class="newHomePagebutton__gradient"><img src="${hostdomainname}/wp-content/themes/mateuszmrozowski/img/svg/arrow.svg" alt=""></div>`;
		button.innerHTML += buttonAppend;
	}
});
